require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./extension-school-2-4-3.json") })
        }
      }, "path---extension-school-2-4-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---extension-school-2-4-3!./.cache/json/extension-school-2-4-3.json
// module id = 430
// module chunks = 231608221292675